export default __webpack_public_path__ + "static/meci-amerex-logo-plain-95d917ecfb767cb5f93014b62b0add12.svg";